import OvertimeManagementComponent from '../OvertimeManagementComponent.vue'

export default [
    {
        path: '/overtime-management',
        name: 'OvertimeManagement',
        meta: {
            layout: 'default',
            requiresAuth: true,
            allowedRoles: [1] // Super Admin only (role_id: 1)
        },
        component: OvertimeManagementComponent
    }
]
